import { i18n } from 'wdz-common-components';

export default function getI18nByKey(key, ...args) {
  return i18n.t(key, ...args);
}
